/**
 * Werte, die Backend UND Frontend brauchen und die synchron bleiben müssen -
 * z.B. weil eine Rolle im Frontend ausgeblendete Buttons UND im Backend
 * abgelehnte Requests steuert. Eine einzige Quelle statt zwei Kopien, die
 * auseinanderlaufen können.
 */

export const ROLES = ['ADMIN', 'OPERATOR', 'VIEWER'] as const;

/**
 * Wer darf schreiben (Wiegungen/Kalender/Fahrzeug-Log anlegen, bearbeiten)?
 * VIEWER ist im Altsystem als "nur Lesen" beworben, konnte aber durch fehlende
 * Rollenprüfung in Export/Statistik-Endpunkten trotzdem exportieren - hier
 * bewusst explizit gemacht statt implizit über fehlende Checks.
 */
export const CAN_WRITE_WEIGHINGS: readonly string[] = ['ADMIN', 'OPERATOR'];
export const CAN_MANAGE_MASTER_DATA: readonly string[] = ['ADMIN'];
export const CAN_MANAGE_USERS: readonly string[] = ['ADMIN'];
export const CAN_VIEW_AUDIT_LOG: readonly string[] = ['ADMIN'];
export const CAN_EXPORT: readonly string[] = ['ADMIN', 'OPERATOR', 'VIEWER'];

export const PAGINATION_DEFAULT_PAGE_SIZE = 50;
export const PAGINATION_MAX_PAGE_SIZE = 500;

/**
 * Das Altsystem addierte pauschal +7200 Sekunden auf `time()`, um eine falsch
 * konfigurierte Server-Zeitzone auszugleichen. Hier stattdessen einmal fest
 * definiert und im Backend über `process.env.TZ` bzw. Intl/date-fns-tz
 * korrekt gesetzt statt manuell verschoben.
 */
export const APP_TIMEZONE = 'Europe/Berlin';

/** Gewicht wird intern IMMER in kg gespeichert (Decimal) - t nur eine reine Anzeige-Formatierung. */
export const KG_PER_TONNE = 1000;

export function kgToTonnes(kg: number): number {
  return kg / KG_PER_TONNE;
}

export function tonnesToKg(tonnes: number): number {
  return tonnes * KG_PER_TONNE;
}

export const REPORT_TYPES = ['GENERIC', 'BIEWER'] as const;
export const EXPORT_FORMATS = ['CSV', 'EXCEL'] as const;
export const WEIGHING_SOURCES = ['MANUAL', 'OCR'] as const;

/** Erlaubte Datei-Typen für Wiegeschein-Uploads, geprüft per Magic-Bytes (nicht per Client-MIME-Header). */
export const ALLOWED_DOCUMENT_MIME_TYPES = ['image/jpeg', 'image/png', 'application/pdf'] as const;
export const MAX_DOCUMENT_SIZE_BYTES = 15 * 1024 * 1024;
